import { render } from "./ElementsPanel.vue?vue&type=template&id=b00ea676&scoped=true"
import script from "./ElementsPanel.vue?vue&type=script&lang=js"
export * from "./ElementsPanel.vue?vue&type=script&lang=js"

import "./ElementsPanel.vue?vue&type=style&index=0&id=b00ea676&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00ea676"]])

export default __exports__